import { render, staticRenderFns } from "./DefaultPayoutSettings.vue?vue&type=template&id=21f43b9a&scoped=true&"
import script from "./DefaultPayoutSettings.vue?vue&type=script&lang=js&"
export * from "./DefaultPayoutSettings.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPayoutSettings.vue?vue&type=style&index=0&id=21f43b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f43b9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSelect,VTextField})
